<template>
  <section class="about-b2b">
    <div class="container">
      <div class="about-b2b__content">
        <div class="about-b2b__text">
          <h2 class="title">Что такое B2B?</h2>
          <p class="subtitle">
            <strong>B2B (Business-to-Business)</strong> — это формат
            взаимодействия, при котором одни компании предлагают свои товары,
            услуги или решения другим компаниям. Это не просто торговля — это
            партнёрства, контракты, доверие и масштаб.
          </p>
          <ul class="benefits">
            <li>Долгосрочные деловые связи</li>
            <li>Крупные сделки и оптовые закупки</li>
            <li>Профессиональная коммуникация</li>
            <li>Ценностный вклад в развитие отрасли</li>
          </ul>
        </div>
        <div class="about-b2b__image">
          <img
            src="@/assets/images/about-icons/b2b.svg"
            alt="B2B illustration"
          />
        </div>
      </div>
      <p class="conclusion">
        В X-Global мы создаём пространство, где компании находят друг друга и
        строят бизнес без рисков.
      </p>
    </div>
  </section>
</template>

<style scoped lang="scss">
.about-b2b {
  background-image: url("../../assets/images/background-benefits.png");
  color: #fff;
  padding: 64px 20px;
  background-size: cover;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    // padding: 0 20px;
  }

  &__content {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 40px;
  }

  &__text {
    flex: 1 1 500px;
  }

  .title {
    font-size: 45px;
    font-weight: 700;
    margin-bottom: 20px;

    @media (max-width: 768px) {
      font-size: 24px;
    }
  }

  .subtitle {
    font-size: 22px;
    line-height: 1.6;
    margin-bottom: 20px;
    margin-top: 32px;

    @media (max-width: 768px) {
      font-size: 18px;
    }
  }

  .benefits {
    list-style: none;
    padding-left: 0;
    margin-bottom: 20px;
    margin-top: 50px;

    li {
      position: relative;
      padding-left: 20px;
      margin-bottom: 8px;
      font-size: 22px;

      @media (max-width: 768px) {
        font-size: 18px;
      }

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 12px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #fff; // основной зелёный цвет
      }
    }
  }

  .conclusion {
    font-size: 45px;
    font-weight: 600;
    margin-top: 24px;

    @media (max-width: 768px) {
      font-size: 24px;
    }
  }

  .gradient-text {
    background: linear-gradient(90deg, #00c782 0%, #016542 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    display: inline-block;
  }

  &__image {
    text-align: center;
    box-shadow: 0px 8px 24px 0px rgba(129, 135, 189, 0.15);
    backdrop-filter: blur(150px);
    border-radius: 50%;
    width: 400px;
    height: 400px;
    align-items: center;
    justify-content: center;
    display: flex;

    @media (max-width: 768px) {
      width: 200px;
      height: 200px;
    }

    img {
      max-width: 100%;
      height: auto;
    }
  }
}
</style>
